<btw-load-panel *ngIf="isProcessingFilesInProgress" text="Processing files in progress..."></btw-load-panel>

<div class="wrapper">
    <form [formGroup]="form">
        <div class="sidebar">
            <div class="top-part">
                <img src="./assets/between_logo_transparent.png">
                <span>BSA Tool</span>
            </div>
            <div class="divider"></div>
            <div class="middle-part">
                <div class="group">
                    <div class="title">Indicators</div>
                    <div class="list">
                        @if(isIndicatorDisabled) {
                        <btw-tooltip text="Please insert API key and analysis id">
                        </btw-tooltip>
                        }
                        <span #defaultSideBarItem (click)="handleSideBarItemChange('Salary')"
                            [ngClass]="{'active': selectedIndicator === 'Salary', 'disabled': isIndicatorDisabled}">Salaries</span>
                        <span (click)="handleSideBarItemChange('IncomeOutcome')"
                            [ngClass]="{'active': selectedIndicator === 'IncomeOutcome', 'disabled': isIndicatorDisabled}">Income
                            and Outcome</span>
                        <span (click)="handleSideBarItemChange('TaxesAndContributions')"
                            [ngClass]="{'active': selectedIndicator === 'TaxesAndContributions', 'disabled': isIndicatorDisabled}">Taxes
                            And Contributions</span>
                        <span (click)="handleSideBarItemChange('InternalTransfer')"
                            [ngClass]="{'active': selectedIndicator === 'InternalTransfer', 'disabled': isIndicatorDisabled}">Internal
                            Transfers</span>
                        <span (click)="handleSideBarItemChange('Loans')"
                            [ngClass]="{'active': selectedIndicator === 'Loans', 'disabled': isIndicatorDisabled}">Loans</span>
                        <span (click)="handleSideBarItemChange('PrivateLoans')"
                            [ngClass]="{'active': selectedIndicator === 'PrivateLoans', 'disabled': isIndicatorDisabled}">Private
                            Loans</span>
                        <span (click)="handleSideBarItemChange('RoundPayments')"
                            [ngClass]="{'active': selectedIndicator === 'RoundPayments', 'disabled': isIndicatorDisabled}">Round
                            Payments</span>
                        <span (click)="handleSideBarItemChange('ElectricityPayments')"
                            [ngClass]="{'active': selectedIndicator === 'ElectricityPayments', 'disabled': isIndicatorDisabled}">Electricity
                            Payments</span>
                        <span (click)="handleSideBarItemChange('PhoneBillPayments')"
                            [ngClass]="{'active': selectedIndicator === 'PhoneBillPayments', 'disabled': isIndicatorDisabled}">Phone
                            Bill Payments</span>
                        <span (click)="handleSideBarItemChange('Factoring')"
                            [ngClass]="{'active': selectedIndicator === 'Factoring', 'disabled': isIndicatorDisabled}">Factoring</span>
                        <span (click)="handleSideBarItemChange('TopSuppliers')"
                            [ngClass]="{'active': selectedIndicator === 'TopSuppliers', 'disabled': isIndicatorDisabled}">Top
                            Suppliers</span>
                        <span (click)="handleSideBarItemChange('TopBuyers')"
                            [ngClass]="{'active': selectedIndicator === 'TopBuyers', 'disabled': isIndicatorDisabled}">Top
                            Buyers</span>
                    </div>
                </div>
                <div class="group">
                    <div class="title">Financials</div>
                    <div class="list">
                        @if(isIndicatorDisabled) {
                        <btw-tooltip text="Please insert API key and analysis id">
                        </btw-tooltip>
                        }
                        <span (click)="handleSideBarItemChange('FinancialStatements')"
                            [ngClass]="{'active': selectedIndicator === 'FinancialStatements', 'disabled': isIndicatorDisabled}">Financial
                            Statement Mapping</span>
                    </div>
                </div>
                <div class="group">
                    <div class="title">Statistical Modeling</div>
                    <div class="list" *ngFor="let model of modelsDataSource">
                        <span (click)="handleModelChange(model)"
                            [ngClass]="{'active': selectedModelId === model.id, 'disabled': isIndicatorDisabled}">{{model.name}}</span>
                    </div>
                </div>
            </div>
            @if(!isApiKeyValid) {
            <div class="bottom-part">
                <div class="api-key-container">
                    <span>API key</span>
                    <btw-text-box formControlName="apiKey">
                        <btw-validator>
                            <btw-validation-rule errorType="required" message="Required field"> </btw-validation-rule>
                            <btw-validation-rule errorType="pattern" message="Wrong API key format">
                            </btw-validation-rule>
                        </btw-validator>
                    </btw-text-box>
                </div>
            </div>
            }
        </div>

        <div class="main">
            <div class="header">

                <div class="analysis">
                    @if(isApiKeyValid) {
                    <btw-select-box formControlName="analysisId" [data]="analysesDataSource" label="Analysis"
                        placeholder="Choose Analysis" labelExpr="label" valueExpr="value" [searchable]="false"
                        [clearable]="false" />
                    }
                </div>
                <div class="action">
                    <div class="ht-20"></div>
                    @if(isApiKeyValid) {
                    <btw-button appearance="secondary" color="green" text="New analysis"
                        (onClick)="handleOpenBankStatementsUploader()" />
                    }
                </div>

            </div>
            <div class="body">
                <div class="charts">
                    @switch (selectedIndicator) {
                    @case ("Salary") {
                    <generic-indicator-analysis [analysisId]="selectedAnalysisId!" indicatorName="Salary"
                        description="This indicator shows activities related to salary payments. It can indicate an issue with the company liquidity in case the salary payments are not paid out in regular intervals and/or there is a change in the pattern or size of payouts." />
                    }
                    @case ("IncomeOutcome") {
                    <generic-indicator-analysis [analysisId]="selectedAnalysisId!" indicatorName="IncomeOutcome"
                        description="This indicator shows activities related to income and outcome payments. It can indicate issues with company's ability to collect payments, or changes in the dynamics of inflows and outflows that can hint at an underlying problem with liquidity." />
                    }
                    @case ("TaxesAndContributions") {
                    <generic-indicator-analysis [analysisId]="selectedAnalysisId!" indicatorName="TaxesAndContributions"
                        description="Taxes and contributions can be paid up to 30 days after the salaries. Increase in duration between salary and taxes payment could indicate that the company is struggling to meet its obligations." />
                    }
                    @case ("InternalTransfer") {
                    <generic-indicator-analysis [analysisId]="selectedAnalysisId!" indicatorName="InternalTransfer"
                        description="This indicator shows internal transfers. Increased activity or changes of pattern could indicate that the company struggles to collect funds for paying certain obligations." />
                    }
                    @case ("Loans") {
                    <generic-indicator-analysis [analysisId]="selectedAnalysisId!" indicatorName="Loans"
                        description="This indicator shows loan payments performed by the company. It can indicate an underyling issue by showing that the company is struggling to pay its monthly obligations in a consistent manner. It can also indicate amount of debt taken by the company." />
                    }
                    @case ("PrivateLoans") {
                    <generic-indicator-analysis [analysisId]="selectedAnalysisId!" indicatorName="PrivateLoans"
                        description="This indicator shows loans made to and from the company that are not bank loans (e.g. loans made by the owner of the company, or a connected entity). An increase in private loans usually means instability in company's liquidity position." />
                    }
                    @case ("RoundPayments") {
                    <generic-indicator-analysis [analysisId]="selectedAnalysisId!" indicatorName="RoundPayments"
                        description="This indicator shows inflows and outflows that are round on last 6 digits (e.g. 100,000). An increase of round outflows could mean the company has an issue with being able to pay its obligations." />
                    }
                    @case ("ElectricityPayments") {
                    <generic-indicator-analysis [analysisId]="selectedAnalysisId!" indicatorName="ElectricityPayments"
                        description="This indicator shows the dynamics of electricity bill payments. These utility payments should be regular. Any payment missed could indicate a potential problem." />
                    }
                    @case ("PhoneBillPayments") {
                    <generic-indicator-analysis [analysisId]="selectedAnalysisId!" indicatorName="PhoneBillPayments"
                        description="This indicator shows the dynamics of phone bill payments. These utility payments should be regular. Any payment missed could indicate a potential problem." />
                    }
                    @case ("Factoring") {
                    <generic-indicator-analysis [analysisId]="selectedAnalysisId!" indicatorName="Factoring"
                        description="This indicator shows factoring usage, both incoming and outgoing payments to factoring companies (excluding banks). It is a valuable indicator since this cannot be seen in the published financial statements." />
                    }
                    @case ("TopSuppliers") {
                    <stacked-indicator-analysis [analysisId]="selectedAnalysisId!" indicatorName="TopSuppliers"
                        description="This indicator shows top 5 suppliers of the company, per month. It can indicate a loss of an important supplier or an introduction of a new one." />
                    }
                    @case ("TopBuyers") {
                    <stacked-indicator-analysis [analysisId]="selectedAnalysisId!" indicatorName="TopBuyers"
                        description="This indicator shows top 5 buyers of the company, per month. It can indicate a loss of an important buyer or an introduction of a new one." />
                    }
                    @case ("FinancialStatements") {
                    <financial-statement-analysis [analysisId]="selectedAnalysisId!" />
                    }
                    @case ("Model") {
                    <app-model-details *ngIf="selectedIndicator === 'Model' && selectedModelId !== null" [modelId]="getModelId" [analysisId]="selectedAnalysisId"></app-model-details>
                    }
                    @default {
                    <div class="intro">
                        <img src="./assets/between_logo.png">
                        <span>Bank Statement Analysis - Advanced analysis of companies' daily transactions</span>
                    </div>
                    }
                    }
                </div>
            </div>
        </div>
    </form>
</div>